const API_URL = process.env.REACT_APP_API_URL;

export function addToCart(item) {
  return new Promise(async (resolve) => {
    const response = await fetch(`${API_URL}/cart`, {
      method: 'POST',
      body: JSON.stringify(item),
      headers: { 'content-type': 'application/json' },
      credentials: "include",
    });
    const data = await response.json();
    resolve({ data });
  });
}

export function fetchItemsByUserId() {
  return new Promise(async (resolve) => {
    const response = await fetch(`${API_URL}/cart`, {
      credentials: "include",
    });
    const data = await response.json();
    resolve({ data });
  });
}

export function updateCart(update) {
  return new Promise(async (resolve) => {
    const response = await fetch(`${API_URL}/cart/${update.id}`, {
      method: 'PATCH',
      body: JSON.stringify(update),
      headers: { 'content-type': 'application/json' },
      credentials: "include",
    });
    const data = await response.json();
    resolve({ data });
  });
}

export async function deleteItemFromCart(itemId) {
  await fetch(`${API_URL}/cart/${itemId}`, {
    method: 'DELETE',
    headers: { 'content-type': 'application/json' },
    credentials: "include",
  });

  return { data: { id: itemId } };
}

export function resetCart() {
  return new Promise(async (resolve) => {
    const response = await fetchItemsByUserId();
    const items = response.data;

    for (let item of items) {
      await deleteItemFromCart(item.id);
    }

    resolve({ status: 'success' });
  });
}